import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { AppThemeProvider } from './context/AppThemeContext';
import { BrowserRouter } from 'react-router-dom'

// import 'bootstrap/dist/css/bootstrap.min.css';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
  <AppThemeProvider>
    <App />
  </AppThemeProvider>-
  </BrowserRouter>
);

reportWebVitals();

